import { render } from "./ModalShareMedicalRecord.vue?vue&type=template&id=514f628a"
import script from "./ModalShareMedicalRecord.vue?vue&type=script&lang=js"
export * from "./ModalShareMedicalRecord.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__